import { tokens } from '@fluentui/react-components';
import type { CSSProperties } from 'react';

export const COMPACT_CONTROL_HEIGHT = '2rem';
export const COMPACT_ACTION_SIZE = '1.75rem';
export const COMPACT_CONTROL_RADIUS = tokens.borderRadiusMedium;

export const selectedControlStyles: CSSProperties = {
  border: `2px solid ${tokens.colorCompoundBrandStroke}`,
  backgroundColor: tokens.colorNeutralBackground1,
  color: tokens.colorNeutralForeground1,
  fontWeight: tokens.fontWeightSemibold,
};

export const selectedControlIconStyles = {
  color: tokens.colorBrandForeground1,
};
